// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2uBWs","title":"_2Emu8","intro":"_3L2jE"};